<mat-card>
  <h2 translate>request.insuranceTitle</h2>
  <form [formGroup]="insuranceForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="100" fxFlex.gt-sm="50">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="insuranceSelect"
          [id]="'selectInsurance'"
          [dataInput]="insuranceValues"
          [placeholder]="'request.insuranceLabel'"
          [isRequired]="true"
          [showErrors]="insuranceForm?.controls?.insuranceSelect?.errors"
        ></scf-custom-select-search>
      </div>
    </div>
  </form>
</mat-card>
